import { ColTypeDef, ICellEditorParams, ValueFormatterParams } from 'ag-grid-community';
import { useSPIntl } from 'hooks/useIntl';
import { useMemo } from 'react';
import { LabelCellRenderer } from 'routes/secondary-market-batch/grid/components/label-cell-renderer';
import { RowData } from 'state/workspaces/secondary-market/batch/model';

export function useDatesArrayColumnType(): ColTypeDef<RowData, RowData[keyof RowData]> {
  const { formatDisplayedDate } = useSPIntl();

  return useMemo(
    () => ({
      cellEditor: 'agRichSelectCellEditor',
      valueFormatter: ({ value }: ValueFormatterParams<RowData>) => {
        return value ? formatDisplayedDate(value) : '';
      },
      filter: 'agDateColumnFilter',
      filterParams: {
        filterOptions: ['equals', 'notEqual', 'lessThanOrEqual', 'greaterThanOrEqual'],
        inRangeInclusive: true,
      },
      cellEditorParams: {
        multiSelect: false,
        values: ({ colDef, data }: ICellEditorParams<RowData, string>) => {
          const dates = data.metadata[colDef.context.metadataId];
          return dates ?? [];
        },
        formatValue: (value?: string | null) => value && formatDisplayedDate(value),
      },
      cellRenderer: LabelCellRenderer,
    }),
    [formatDisplayedDate],
  );
}
